'use client';

import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * A considered "nothing here yet" moment — never a blank region (guide rule:
 * empty/null renders EmptyState, never blank).
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 rounded-[var(--radius-lg)]',
        'border border-dashed border-[var(--border)] bg-[var(--surface-soft)] px-8 py-14 text-center',
        className,
      )}
    >
      {icon && (
        <span className="mb-2 flex h-13 w-13 items-center justify-center rounded-full bg-[var(--muted)] text-[var(--text-muted)] shadow-[var(--shadow-sm)]">
          {icon}
        </span>
      )}
      <p className="text-base font-semibold text-[var(--text-primary)]">{title}</p>
      {description && (
        <p className="max-w-sm text-[0.95rem] leading-relaxed text-[var(--text-muted)]">
          {description}
        </p>
      )}
      {action && <div className="mt-3">{action}</div>}
    </div>
  );
}
